module.exports = __webpack_public_path__ + "img/alert_triangle.9eb84136.svg";